import React from "react"

import TableComponent from "./table-component"

import ThemeHeader from "./theme-header-container"
import GrantHeader from "./grant-header-container"

class TableContainer extends React.Component {

	state = {
		shownThemes: []
	}

	render() {
		const def = this._getDef()
		return (
			<TableComponent 
				tableDefinition={def.table}
				data={def.data}
				onToggleTheme={this._handleToggleTheme.bind(this)}
				previousYear={this.props.previousYear}
				currentUserType = {this.props.currentUserType}
			/>
		)
	}

	_handleToggleTheme(theme) {
		var shownThemes = this.state.shownThemes
		var index
		if ((index = shownThemes.indexOf(theme.id)) !== -1) {
			shownThemes.splice(index, 1)
		} else {
			shownThemes.push(theme.id)
		}
		this.setState({shownThemes})
	}

	_getDef() {
		var def = {
			table: { rows: [] },
			data: []
		}

		var index=0, rest=0
		var subthemes, projects
		var themes = this.props.ppi.investment_themes

		themes.map(investment_theme => {

			subthemes = investment_theme.themes.filter(t => {
				projects = t.projects.filter(p => p.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).length > 0)
				return projects.length > 0
			})
			projects = investment_theme.projects.filter(p => p.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).length > 0)

			if (subthemes.length > 0 || projects.length > 0) {
				def.table.rows.push({
					title: investment_theme.name,
					item: investment_theme,
					isShown:  (this.state.shownThemes.indexOf(investment_theme.id) !== -1),
					cellComponents: [{
						index: 0,
						component: ThemeHeader
					}],
					index,
					cellProps: {
						format  : "0,0",
						language: "fr-FR",
						type    : "numeric",
						mantissa: 0
					},
					className: "invest-theme",
					readOnly: true
				})

				def.data.push(this._reduceThemeGrantAmounts(investment_theme))
				def.data[index].unshift(investment_theme.name)

				index++

				if (this.state.shownThemes.indexOf(investment_theme.id) !== -1) {
					subthemes.map(subtheme => {
						def.table.rows.push({
							title: subtheme.name,
							item: subtheme,
							isSubTheme: true,
							isShown:  (this.state.shownThemes.indexOf(subtheme.id) !== -1),
							cellComponents: [{
								index: 0,
								component: ThemeHeader
							}],
							index,
							cellProps: {
								format  : "0,0",
								language: "fr-FR",
								type    : "numeric",
								mantissa: 0
							},
							className: "invest-subtheme",
							readOnly: true
						})

						def.data.push(this._reduceSubThemeGrantAmounts(subtheme))
						def.data[index].unshift(subtheme.name)

						index++

						if (this.state.shownThemes.indexOf(subtheme.id) !== -1) {
							subtheme.projects.filter(p => p.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).length > 0).map(project => {
								if (this.props.priorities.length == 0 || this.props.priorities.indexOf(project.priority) !== -1) {
									//project.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).map(grant => {

										def.table.rows.push({
											title: project.name, //grant.grant.name,
											project,
											//grant,
											theme: investment_theme,
											subtheme: subtheme,
											isSubGrant: true,
											cellComponents: [{
												index: 0,
												component: GrantHeader
											}],
											index,
											cellProps: {
												format  : "0,0",
												language: "fr-FR",
												type    : "numeric",
												mantissa : 0
											},
											className: "invest-project" + (project.visible ? "" : " project-disabled"),
											readOnly: true
										})

										def.data.push(this._reduceProjectGrantAmounts(project))
										def.data[index].unshift(project.name)//grant.grant.name)

										index++
									//})
								}
							})
						}
					})

					projects.map(project => {
						if (this.props.priorities.length == 0 || this.props.priorities.indexOf(project.priority) !== -1) {

							//project.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).map(grant => {

								def.table.rows.push({
									title: project.name, //grant.grant.name,
									project,
									//grant,
									theme: investment_theme,
									cellComponents: [{
										index: 0,
										component: GrantHeader
									}],
									index,
									cellProps: {
										format  : "0,0",
										language: "fr-FR",
										type    : "numeric",
										mantissa: 0
									},
									className: "invest-project" + (project.visible ? "" : " project-disabled"),
									readOnly: true
								})

								def.data.push(this._reduceProjectGrantAmounts(project))
								def.data[index].unshift(project.name)//grant.grant.name)

								index++
							//})
						}
					})
				}
			}
		})

		return def
	}

	_reduceThemeGrantAmounts = (theme) => {
		return this.props.ppi.years.filter(y => (y.year >= this.props.current_year)).map(y => {
			var amount = this._reduceSubThemeGrantAmount(y, theme)
			theme.themes.map(t => {
				amount += this._reduceSubThemeGrantAmount(y, t)
			})
			return Math.round(amount)
		})
	}

	_reduceSubThemeGrantAmounts = (subtheme) => {
		return this.props.ppi.years.filter(y => (y.year >= this.props.current_year)).map(y => (
			this._reduceSubThemeGrantAmount(y, subtheme)
		))
	}

	_reduceSubThemeGrantAmount(year, theme) {
		var r = 0
		theme.projects.map(p => {
			if (p.visible && (this.props.priorities.length == 0 || this.props.priorities.indexOf(p.priority) !== -1)) {
				p.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).map(g => {
					r += g.years.find(y => y.year == year.year).amount
				})
			}
		})
		return Math.round(r)
	}

/*
	_reduceProjectGrantAmounts(grant) {
		return grant.years.filter(y => (y.year >= this.props.current_year)).map(y => y.amount)
	}
*/

	_reduceProjectGrantAmounts(project) {
		var amounts = null, current, fromGrant
		project.grants.filter(g => g.awarded == (this.props.row.type == "awarded")).map(grant => {
			fromGrant = grant.years.filter(y => (y.year >= this.props.current_year)).map(y => y.amount)
			if (!amounts) {
				amounts = fromGrant
			} else {
				amounts = amounts.map((a, i) => a + fromGrant[i])
			}
		})
		return amounts
	}

}

export default TableContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/grants/table-container.js